import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('portal.afterservice.widget.as.button');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-portal-afterservice-widget-as-button',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/portal.afterservice.widget.as.button/view.scss */
/* src/app/portal.afterservice.widget.as.button/view.scss: no such file or directory */`],
})
export class PortalAfterserviceWidgetAsButtonComponent implements OnInit {

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.service.render();
    }

    public goToAs() {
        this.service.href('/user/as/apply');
    }
}

export default PortalAfterserviceWidgetAsButtonComponent;